namespace Matrix.DataAudit {
    export interface FactSecurityRow {
        Generation?: number;
        DateKey?: string;
        SecurityId?: number;
        SecurityKey?: number;
        PendingSecurityKey?: number;
        Status?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        SecurityCode?: string;
    }

    export namespace FactSecurityRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'DataAudit.FactSecurity';
        export const deletePermission = 'DataAdmin:SecurityHistory';
        export const insertPermission = 'DataAdmin:SecurityHistory';
        export const readPermission = 'Read:SecurityHistory';
        export const updatePermission = 'DataAdmin:SecurityHistory';

        export declare const enum Fields {
            Generation = "Generation",
            DateKey = "DateKey",
            SecurityId = "SecurityId",
            SecurityKey = "SecurityKey",
            PendingSecurityKey = "PendingSecurityKey",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            SecurityCode = "SecurityCode"
        }
    }
}
